import script from "./SubscriptionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPage.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPage.vue?vue&type=style&index=0&id=3355463f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3355463f"]])

export default __exports__